import styled, { css } from 'styled-components'

type StyleButtonProps = {
  size?: 'display' | 'mid' | 'small' | 'custom',
  customStyles?:any,
  disabled?:boolean,
  active?:boolean,
  isProps?:boolean,
}
function styleMyEl(size:any, customStyles:any, disabled:any) {
  switch (size) {
    case 'display':
      return css`
        width: 40px;
        height: 40px;
        box-shadow:${({theme}) => disabled ? '' : theme.shadows.control};
        ${customStyles}
      `;
    case 'mid':
      return css`
        width: 40px;
        height: 36px;
        box-shadow:${({theme}) => disabled ? '' : theme.shadows.control};
        ${customStyles}
      `;
    case 'small':
      return css`
        width: 30px;
        height: 30px;
        ${customStyles}
      `;
    default:
      return css`
        width: 30px;
        height: 30px;
        ${customStyles}
      `;
  }
}
const IconButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['size', 'customStyles', 'active', 'isProps'].includes(prop),
})<StyleButtonProps>`
  background-color: ${({theme, active, isProps}) => isProps ? theme.palette[10] : active ? theme.palette[10] : theme.palette[10]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1E1E1E;
  border-radius: ${({theme}) => theme.radius.control};
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  box-shadow:${({theme, active}) => active ? theme.isDark ? theme.shadows.focusDark : theme.shadows.focus : ''};
  border: ${({theme, active, size}) => active ? `1px solid ${theme.accent[100]}` : size === 'display' || size === 'mid' ? `1px solid ${theme.grey[400]}` : 'none'};
  ${({size, customStyles, disabled}) => styleMyEl(size, customStyles, disabled)}

  &:hover:not(:disabled){
    box-shadow: ${({theme, disabled, active}) => disabled || active ? '' : theme.shadows.hover};
    background: ${({theme}) => theme.palette[200]};
    cursor: pointer;
  }
  &:active:not(:disabled){
    
    border: ${({theme, active, isProps}) =>  `1px solid ${theme.accent[100]}`};
    background-color: ${({theme}) => theme.base.white};
    box-shadow: ${({theme, disabled}) => disabled ? '' : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:focus-visible{
    outline: none;
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:disabled{
    /* background: #FCFBFC; */
    background-color:${({theme}) => theme.isDark ? '#111111' : theme.palette[10]};
    border-width:1px;
    border-style:solid;
    border-color:${({theme}) => theme.isDark ? '#242424' : theme.grey[400]};
    box-shadow: '0px 0px 0px 0px #FFFFF';
    opacity:${({theme}) => theme.isDark ? '' : '0.5'};
    cursor: not-allowed;
  }
`

export default IconButton
